import { render, staticRenderFns } from "./struggling-domain-card.vue?vue&type=template&id=cf616ad4&scoped=true"
import script from "./struggling-domain-card.ts?vue&type=script&lang=ts&external"
export * from "./struggling-domain-card.ts?vue&type=script&lang=ts&external"
import style0 from "./struggling-domain-card.scss?vue&type=style&index=0&id=cf616ad4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf616ad4",
  null
  
)

export default component.exports